export const MIN_HEIGHT = 200;
export const DEFAULT_MAX_HEIGHT = 400;
export const LEFT_RESIZE = 'left-resize';
export const RIGHT_RESIZE = 'right-resize';
export const TOP_RESIZE = 'top-resize';
export const BOTTOM_RESIZE = 'bottom-resize';
export const NODE_CONTAINER_CLASSNAME = 'node-container ';
